<template lang="html">
<span>
  <router-view />
</span>
</template>

<script>
export default {
  name: 'BaseLayout',
};
</script>
